import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, FormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpParams} from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from 'src/app/_services/project.service';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { SettingService } from 'src/app/_services/setting.service';
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from 'src/app/_services/home.service';

@Component({
  selector: 'app-auto-heal',
  templateUrl: './auto-heal.component.html',
  styleUrls: ['./auto-heal.component.scss']
})
export class AutoHealComponent implements OnInit {
  projectId: string;
  projectData: Object;
  projectSettingData: any;
  TestEnvData: any;
  autoHealData: any;
  feildName: any;
  FeildValue: any;
  formObj: any;
  submitted: boolean;
  updateSettingData: any;
  bugDataToEdit: any;
  bugDataValue: any;
  enableEditPopup: boolean = true;
  feildValue: any;
  fieldName: any;
  updateLocatorFlag: boolean;
  headerOptions = {
    showSetting : false,
    showSearch: false,
    heading : 'Settings',
    data: undefined,
  }
  currentUrl: any;
  previousUrl: any=[];
  previousUrltemp: any;
  agentCheck: boolean;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private project: ProjectService,
    private toastrService:ToastrService,
    private confirmationDialogService:ConfirmationDialogService,
    private setting: SettingService,
    private router:Router,
    private memoryService: MemoryService,
    private urlService:UrlService,
    private homeService: HomeService,
    @Inject( DOCUMENT ) private document: Document,
  ) { }
  @ViewChild('cancelmodal', null) cancelmodal: ElementRef;
  
  ngOnInit() {
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        this.getAllprojectSetting(this.projectId);
        this.project.getProjectById(this.projectId).subscribe((
          data=>{
            this.projectData=data;
            this.headerOptions.data = {
              projectId: this.projectId,
              projectName: data['projectName']
            };
            //set header details
            this.homeService.setHeaderOptions(this.headerOptions);
            //console.log(this.projectData);
           
          }
        ))
      
      }
    )
    if(this.agentCheck)
    {
      this.memoryService.getUrlHistory().subscribe((res)=>
      {
        this.previousUrl =  res;
        if(this.previousUrl.length > 0)
        {
          this.currentUrl =  this.router.url;
          this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
          this.memoryService.setUrlHistory(this.previousUrltemp);
        }
      })
    }
    else
    {
      this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      if(!this.previousUrl){
        this.currentUrl =  this.router.url;
        this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrltemp));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
    }
  }
  geturlName(url) {
    return this.urlService.geturlName(url);
  }
  getAllprojectSetting(projectId){
    this.setting.getAllProjectSetting(projectId).subscribe(
      (data)=>{
        this.projectSettingData = data['projectSettingList'];
        //console.log('allSettingData',this.projectSettingData);
        this.TestEnvData = this.projectSettingData.filter((f)=>f.name == 'envSetting')
        this.TestEnvData= this.TestEnvData[0]
        this.autoHealData = this.TestEnvData.setting.entry.filter((f)=>f.key.includes('auto'));
        //console.log('autoHeal>>',this.autoHealData);
        this.autoHealData.forEach(element => {
          if(element.key == "auto_heal")
          {
            if (element.value.settingValue == 'false') {
              this.updateLocatorFlag = true;
            }
            else {
              this.updateLocatorFlag = false;
            }
          }
        });   
      }
    )
  }

  filterAutoHeal(bugDataToEdit, bugDataValue){
    this.bugDataToEdit = bugDataToEdit;
    this.bugDataValue = bugDataValue;
    if(this.bugDataValue =='false' || this.bugDataValue =='true'){
      this.enableEditPopup = false;
      this.toastrService.clear();
      this.toastrService.info('Use toggle button for edit')
      return;
    }
    else if(this.bugDataToEdit=='auto_heal_locator_timeout' || this.bugDataToEdit=='locator_timeout' || this.bugDataToEdit=='	max_execution_retries'){
      this.enableEditPopup = false;
      this.toastrService.clear();
      this.toastrService.info('Kindly Change Value using Slider bar');
      return;
    }
      // this.updateTestEnvData = true;
      this.updateSettingData =  this.TestEnvData.setting.entry.filter((f)=>f.key == bugDataToEdit)
      //console.log(this.updateSettingData)
  }

  updateSetting(event:any,fieldName) {
    this.feildValue = event.value;
    this.fieldName = fieldName;
    //console.log(this.feildValue);
    var objectForEdit = {}
    objectForEdit[fieldName] = this.feildValue.toString();
    //console.log(objectForEdit);
    this.formObj = objectForEdit;
    this.updateSettingData =  this.TestEnvData.setting.entry.filter((f)=>f.key == this.fieldName)
    //console.log(this.updateSettingData)
    this.updateSettingData[0].value.settingValue = Object.values(this.formObj)[0];
    this.submitted = true;
    //console.log(this.formObj);
   

    this.project.editProjectSetting(this.projectId,this.TestEnvData).subscribe(
      (data)=>{
        //console.log(data);
        this.toastrService.clear();
        this.toastrService.success('Automation setting updated successfully');
        this.cancelmodal.nativeElement.click();
  }
    )
  }
  captureEvent(key,event:any){
    var objectForEdit = {}
    objectForEdit[key] = event.target.checked.toString();
    //console.log(objectForEdit);
    this.formObj = objectForEdit;
    this.updateSettingData =  this.TestEnvData.setting.entry.filter((f)=>f.key == key)
    //console.log(this.updateSettingData)
    this.updateSettingData[0].value.settingValue = Object.values(this.formObj)[0];
    this.submitted = true;
    //console.log(this.formObj);
    //console.log(this.TestEnvData);
    if(this.TestEnvData['@type'])
    {
      let settingType = this.TestEnvData['name'];
      this.TestEnvData.setting.entry.forEach(element => {
          element.value['newPos'] = settingType;
          element.value['savePos'] = settingType;
      });
      delete this.TestEnvData['@type'];
    }

    //console.log(this.TestEnvData);

   

    this.project.editProjectSetting(this.projectId,this.TestEnvData).subscribe(
      (data)=>{
        //console.log(data);
        this.getAllprojectSetting(this.projectId);
        this.toastrService.clear();
        this.toastrService.success('Automation setting updated successfully');
        this.cancelmodal.nativeElement.click();
  }
    )
  }

  onSubmit(editProjectSettingForm){
    this.formObj = editProjectSettingForm.value;
    this.updateSettingData[0].value.settingValue = Object.values(this.formObj)[0];
    this.submitted = true;
    //console.log(this.formObj);
   

    this.project.editProjectSetting(this.projectId,this.TestEnvData).subscribe(
      (data)=>{
        //console.log(data);
        this.getAllprojectSetting(this.projectId);
        this.toastrService.clear();
        this.toastrService.success('Automation setting updated successfully');
        this.cancelmodal.nativeElement.click();
  }
    )
}
}
